import React from "react";
import { Radio } from "@rmwc/radio";
import styled, { css } from "react-emotion";
import { QRCodeImage, HintModal, Input } from "components";
import { redemptionTypeOptions } from "constants";
import { Form, FlexRow, H1, H2, LineButton } from "appStyles";

const StyledRadio = styled(Radio)`
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 15px;
  line-height: 18px;
  font-weight: bold;
`;

export default class RadioOptions extends React.Component {
  state = {
    showPasswordInput: false,
    showQRCode: false,
    pageType: this.props.pageType,
    selectedOption: this.props.value,
  };
  update = (field) => (value) => {
    // console.log("updating with field: " + field + " and value: " + value);
    this.props.actions.updateApplication(field, value);
  };
  hasDeal = () => Object.keys(this.props.deals).length > 0;
  hasReward = () => Object.keys(this.props.rewards).length > 0;
  hasStoreItems = () => Object.keys(this.props.store).length > 0;

  handleRenderQRCode = (optionsType) => {
    if (optionsType == "deal") {
      const { name, dealCode } = this.props.activeApp;
      return this.renderQRCode(optionsType, name, dealCode);
    } else if (optionsType == "reward") {
      const { name, rewardCode } = this.props.activeApp;
      return this.renderQRCode(optionsType, name, rewardCode);
    } else if (optionsType == "featuresRedemption" && this.hasStoreItems()) {
      const { name, featuresRedemptionCode } = this.props.activeApp;
      return this.renderQRCode(optionsType, name, featuresRedemptionCode);
    } else if (optionsType == "punchcard") {
      const { name, punchcardCode } = this.props.activeApp;
      return this.renderQRCode(optionsType, name, punchcardCode);
    } else {
      return null;
    }
  };

  renderQRCode = (optionsType, name, Code) => {
    const marginLeft = "29px";
    const qrCodeName = `${name}_${optionsType}_${new Date().toLocaleDateString()}`;
    // console.log("at " + optionsType + " radio component, rendering qr code...");

    return (
      <QRCodeImage text={Code} name={qrCodeName} marginLeft={marginLeft} />
    );
  };

  handleRenderPassword = (optionsType) => {
    if (optionsType == "deal") {
      // console.log("activating dealsPasswordGenerator");
      const { dealCode } = this.props.activeApp;
      return this.renderPassword(optionsType, dealCode);
    } else if (optionsType == "reward") {
      // console.log("activating rewardsPasswordGenerator");
      const { rewardCode } = this.props.activeApp;
      return this.renderPassword(optionsType, rewardCode);
    } else if (optionsType == "featuresRedemption") {
      // console.log("activating storePasswordGenerator");
      const { featuresRedemptionCode } = this.props.activeApp;
      return this.renderPassword(optionsType, featuresRedemptionCode);
    } else if (optionsType == "punchcard") {
      // console.log("activating punchcardPasswordGenerator");
      const { punchcardCode } = this.props.activeApp;
      // console.log("got code from active app: " + punchcardCode);
      return this.renderPassword(optionsType, punchcardCode);
    } else {
      return null;
    }
  };

  renderPassword = (optionsType, code) => {
    return (
      <React.Fragment>
        {/* <H2 className="dealPassword">Deal Password</H2> */}
        <FlexRow margin="0 0 1em 0">
          {/* <div>
            <div
              style={{
                display: "flex"
              }}
            >
              <H2 margin="0" fontSize="1em">
                Set Password to Redeem Deals (Required):
              </H2>
              <HintModal
                modalLeft="2em"
                position="relative"
                width="470px"
                height="auto"
                margin="auto auto auto 8px"
              >
                <div
                  style={{
                    fontSize: "0.9em"
                  }}
                >
                  <p>
                    In order to redeem a deal, you must set a password. To see
                    how this password will be used, read the redemption type
                    hint above.{" "}
                  </p>
                  <p>
                    In case you pick option 2, you can download your password QR
                    to the left.{" "}
                  </p>
                </div>
              </HintModal>
            </div>
          </div> */}
          <Input
            margin="0"
            width="50%"
            fontSize="1em"
            marginLeft="45px"
            field="Set Password"
            onChange={this.update(optionsType + "Code")}
            defaultValue={code}
          />
        </FlexRow>
      </React.Fragment>
    );
  };

  onSelect = (e) => {
    // console.log("event: ", e.currentTarget.value);
    this.props.setValue(parseInt(e.currentTarget.value));
    // this.props.onChange(this.props.defaultValue ? 0 : 1);
    this.setState({
      selectedOption: parseInt(e.currentTarget.value),
    });
  };

  // handlePageType = () => {
  //   this.setState({
  //     pageType = this.props.pageType
  //   })
  // }
  render() {
    const {
      options, // all options for radio buttons
      value, // deal redemption type
      showPasswordInput,
      showQRCode,
      pageType,
      // punchcardCode,
      name,
    } = this.props;

    const currentValue = options.find((op) => op.value === value);
    return (
      <div>
        {options.map((option) => {
          // console.log("================");
          // console.log(option);
          // console.log("current value from parent: " + value);
          // console.log(this.state.selectedOption);
          // console.log(this.state.selectedOption === option.value); // you are storing
          // console.log("================");

          // const actualVal = currentValue && currentValue.value;
          const isManual = option.value == 1;
          const isCustomerScans = option.value == 2;

          return (
            <div key={option.value}>
              <StyledRadio
                label={option.label}
                value={option.value}
                // key={actualVal}
                name="myRadioGroup"
                checked={value === option.value}
                onChange={this.onSelect}
              ></StyledRadio>
              <p
                style={{
                  margin: "10px 0px",
                  fontSize: "15px",
                  marginLeft: "45px",
                  width: "480px",
                }}
              >
                {option.description}
              </p>
              {showPasswordInput && isManual
                ? this.handleRenderPassword(pageType)
                : null}
              {showQRCode && isCustomerScans
                ? this.handleRenderQRCode(pageType, name)
                : null}
            </div>
          );
        })}
      </div>
    );
  }
}
